(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bozetto-cart-reward"] && !Shopify.designMode) return;
  try {
    (function () {
    // Install one shared observer for cart mutations, no matter how many reward blocks render.
    if (!window.bzCartObserverInstalled) {
      window.bzCartObserverInstalled = true;
      var CART_URL = /\/cart\/(add|change|update|clear)/;
      var notify = function () {
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('bz:cart-changed'));
        }, 300);
      };
      var nativeFetch = window.fetch;
      window.fetch = function (input) {
        var url = (input && input.url) || input || '';
        var request = nativeFetch.apply(this, arguments);
        if (typeof url === 'string' && CART_URL.test(url)) request.then(notify, function () {});
        return request;
      };
      var nativeOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (typeof url === 'string' && CART_URL.test(url)) this.addEventListener('load', notify);
        return nativeOpen.apply(this, arguments);
      };
      ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (name) {
        document.addEventListener(name, notify);
      });
    }

    if (customElements.get('bz-cart-reward')) return;

    var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="8.5" width="17" height="4"/><path d="M5 12.5V20h14v-7.5"/><path d="M12 8.5V20"/><path d="M12 8.5S9.6 8.5 8.5 7 8.4 3.8 10 3.8s2 4.7 2 4.7zM12 8.5s2.4 0 3.5-1.5.1-3.2-1.5-3.2-2 4.7-2 4.7z"/></svg>';
    var GIFT_SM = GIFT.replace('stroke-width="1.9"', 'stroke-width="2.2"');
    var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';

    class BzCartReward extends HTMLElement {
      connectedCallback() {
        this.step = parseInt(this.dataset.step, 10) || 4;
        this.types = (this.dataset.productTypes || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        try {
          this.copy = JSON.parse(this.querySelector('[data-bz-copy]').textContent);
        } catch (error) {
          this.copy = {};
        }
        // Shopify trims text settings on save, so spacing between the parts is added in render().
        for (var key in this.copy) {
          this.copy[key] = (this.copy[key] || '').trim();
        }
        this.onCartChanged = this.refresh.bind(this);
        document.addEventListener('bz:cart-changed', this.onCartChanged);
        this.render(parseInt(this.dataset.count, 10) || 0);
      }

      disconnectedCallback() {
        document.removeEventListener('bz:cart-changed', this.onCartChanged);
      }

      part(name) {
        return this.querySelector('[data-bz-' + name + ']');
      }

      unitCount(items) {
        var types = this.types;
        return items.reduce(function (total, item) {
          return !types.length || types.indexOf(item.product_type) > -1 ? total + item.quantity : total;
        }, 0);
      }

      refresh() {
        var self = this;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) { self.render(self.unitCount(cart.items || [])); })
          .catch(function () {});
      }

      render(count) {
        var c = this.copy;
        var step = this.step;
        var rem = count % step;
        var done = count > 0 && rem === 0;
        var free = Math.floor(count / step);
        var filled = done ? step : rem;
        // Artworks left until (and including) the free one.
        var need = step - rem;
        var badge = this.part('badge');
        var line = this.part('line');
        var pips = '';

        for (var i = 0; i < step; i++) {
          var on = i < filled;
          var gift = i === step - 1;
          var next = gift && !done && filled === step - 1;
          pips += '<span class="bz-pip' + (gift ? ' gift' : '') + (on ? ' on' : '') + (next ? ' next' : '') + '">' + (gift ? GIFT_SM : on ? CHECK : '') + '</span>';
        }

        this.part('pips').innerHTML = pips;
        this.part('fill').style.width = (filled / step) * 100 + '%';
        this.querySelector('.bz').classList.toggle('bz-win', done);
        this.part('kick').innerHTML = c.kicker + ' <span class="hl">' + c.kickerHighlight + '</span>';

        if (count === 0) {
          badge.className = 'bz-badge gift';
          badge.innerHTML = GIFT;
          line.innerHTML = c.emptyLine + ' <span class="free">' + c.emptyFree + '</span>.';
        } else if (done) {
          badge.className = 'bz-badge gift';
          badge.innerHTML = GIFT;
          line.innerHTML = '<span class="free">' + (free > 1 ? free + ' ' + c.doneMany : c.doneOne) + '</span> ' + c.doneSuffix;
        } else if (need === 1) {
          badge.className = 'bz-badge';
          badge.innerHTML = '<span class="n">1</span>';
          line.innerHTML = c.addMore + ' <span class="g">' + c.oneMore + '</span> – <span class="free">' + c.oneMoreFree + '</span>';
        } else {
          badge.className = 'bz-badge';
          badge.innerHTML = '<span class="n">' + need + '</span>';
          line.innerHTML = c.addMore + ' <span class="g">' + need + ' ' + c.manyMore + '</span> – <span class="free">' + c.manyMoreFree + '</span>.';
        }
      }
    }

    customElements.define('bz-cart-reward', BzCartReward);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bozetto-product-guides"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bz-product-guides')) {
    class BzProductGuides extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = (event) => {
        const toggle = event.target.closest('.bzg-item');
        if (toggle) {
          const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
          this.closeAll();
          if (!wasOpen) this.open(toggle);
          return;
        }
        if (event.target.closest('.bzg-close')) this.closeAll(true);
      };

      open(toggle) {
        const panel = this.querySelector(`#${toggle.getAttribute('aria-controls')}`);
        if (!panel) return;
        toggle.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
        panel.querySelector('.bzg-inner')?.removeAttribute('inert');
      }

      closeAll(restoreFocus = false) {
        const openToggle = this.querySelector('.bzg-item[aria-expanded="true"]');
        this.querySelectorAll('.bzg-item').forEach((item) => item.setAttribute('aria-expanded', 'false'));
        this.querySelectorAll('.bzg-panel').forEach((panel) => {
          panel.classList.remove('is-open');
          panel.querySelector('.bzg-inner')?.setAttribute('inert', '');
        });
        if (restoreFocus) openToggle?.focus();
      }
    }

    customElements.define('bz-product-guides', BzProductGuides);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bozetto-review-carousel"] && !Shopify.designMode) return;
  try {
    class BzReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-bzr-slide]')];
      if (!this.slides.length) return;

      this.index = 0;
      this.counter = this.querySelector('[data-bzr-current]');
      this.interval = Number(this.dataset.interval) || 5000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelector('[data-bzr-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-bzr-next]')?.addEventListener('click', () => this.go(this.index + 1, true));

      for (const event of ['mouseenter', 'focusin']) this.addEventListener(event, () => this.stop());
      for (const event of ['mouseleave', 'focusout']) this.addEventListener(event, () => this.start());

      this.go(0);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(nextIndex, userInitiated = false) {
      const total = this.slides.length;
      const previous = this.index;
      this.index = (nextIndex + total) % total;
      // Only the outgoing and incoming slides change; touching all of them every tick
      // produced hundreds of needless attribute mutations per minute.
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        if (this.initialized && i !== previous && !active) return;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.initialized = true;
      if (this.counter) this.counter.textContent = this.index + 1;
      if (userInitiated) this.start();
    }

    start() {
      this.stop();
      if (this.reducedMotion || this.slides.length < 2 || Shopify.designMode) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('bz-review-carousel')) {
    customElements.define('bz-review-carousel', BzReviewCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
